import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

/**
 * Restricts a route to the `super_admin` role only. Unlike
 * `superUserGuard` (which also allows `admin`), this is the strict guard for
 * organization management actions.
 */
export const superAdminGuard: CanActivateFn = () => {
  const role = inject(AuthService).currentUser()?.role;
  if (role === 'super_admin') return true;
  inject(Router).navigate(['/admin']);
  return false;
};
